//此js定义VUE原型链上的方法

import axios from 'axios';
// import { setTimeout } from "timers";
import { getSystemLanguage } from '@/utils/index.js';

export default {
  install(Vue, options) {
    /*
     * 项目的comfirm弹出框
     * 将element组件里的MessageBox弹框适当封装的方法
     *
     * @param {string} msg 消息内容
     * @param {string} type 消息类型，用于显示图标 可选值有 success / info / warning / error
     * @param {funtion} confirm 确认按钮的回调方法
     * @param {funtion} cancel 取消按钮的回调方法
     */
    Vue.prototype._confirm = function ({
      msg = Vue.prototype._i18n.t('common.prototype.defaultMsg'),
      isHtml = false,
      type = '',
      confirm = () => {},
      cancel = () => {},
      confirmButtonText = '',
      cancelButtonText = '',
      confirmButtonClass = '',
      cancelButtonClass = '',
    } = {}) {
      Vue.prototype
        .$confirm(msg, Vue.prototype._i18n.t('common.prototype.defaultTitle'), {
          confirmButtonText: confirmButtonText || Vue.prototype._i18n.t('common.prototype.confirmButtonText'),
          cancelButtonText: cancelButtonText || Vue.prototype._i18n.t('common.prototype.cancelButtonText'),
          type: type,
          center: true,
          roundButton: true,
          closeOnClickModal: true,
          showClose: false,
          dangerouslyUseHTMLString: isHtml,
          confirmButtonClass: `${confirmButtonClass} confirmButtonClass`,
          cancelButtonClass: `${cancelButtonClass} cancelButtonClass`,
          customClass: 'customClass',
        })
        .then(confirm)
        .catch(cancel);
    };

    /*
     * 项目的alert弹出框
     * 将element组件里的MessageBox弹框适当封装的方法
     *
     * @param {string} msg 消息内容
     * @param {string} type 消息类型，用于显示图标 可选值有 success / info / warning / error
     * @param {funtion} confirm 确认按钮的回调方法
     */
    Vue.prototype._alert = function ({
      title = Vue.prototype._i18n.t('common.prototype.defaultTitle'),
      msg = Vue.prototype._i18n.t('common.prototype.defaultMsg'),
      type = '',
      confirm = () => {},
    } = {}) {
      Vue.prototype.$alert(msg, title, {
        confirmButtonText: Vue.prototype._i18n.t('common.prototype.confirmButtonText'),
        type: type,
        center: true,
        roundButton: true,
        closeOnClickModal: true,
        showClose: false,
        confirmButtonClass: 'confirmButtonClass',
        customClass: 'customClass',
        callback: confirm,
      });
    };

    /*
     * 项目的message弹出框
     * 将element组件里的Message弹框适当封装的方法
     * @param {string} type 消息类型，用于显示图标 可选值有 success / info / warning / error
     * @param {string} msg 消息内容
     * @param {funtion} duration 显示时间 默认800
     */
    Vue.prototype._message = function (
      msg = Vue.prototype._i18n.t('common.prototype.defaultMsg'),
      { type = 'info', duration = 3000 } = {},
    ) {
      Vue.prototype.$message({
        message: msg,
        type: type,
        duration: duration,
      });
    };

    /*
     * 项目的加载动画
     * 将element组件里的Loading加载适当封装的方法
     *
     * 用法参考如下：
     *
     *   () => {
     *       var loading = this._loading();
     *       setTimeout(() => {
     *           loading.close();
     *       }, 2000);
     *   }
     *
     */
    Vue.prototype._loading = function () {
      return Vue.prototype.$loading({
        lock: true,
        spinner: 'loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
    };

    /*
     * 最小加载时长，如果请求时间过快，页面的加载动画会一闪一下很不美观。
     *
     * 用法参考以下 Vue.prototype._ajax 的用方法
     *
     */
    Vue.prototype._loadingMinTime = function (min = 400) {
      let now = Date.now();
      return {
        extraTime: () => Math.max(min - (Date.now() - now), 0),
        loadingTime: () => Math.max(Date.now() - now, min),
      };
    };

    /*
     * axios的请求头配置
     */
    Vue.prototype._axios = axios.create({
      headers: {
        // "Content-Type": "application/json",
        timeout: 3000,
      },
    });

    /*
     * axios的请求拦截器
     */
    Vue.prototype._axios.interceptors.request.use((config) => {
      // 添加系统语言
      if (config.headers) {
        config.headers['Accept-Language'] = getSystemLanguage();
      }
      return config;
    });

    /*
     * ajax函数的请求方法（对axios的简单封装）
     *
     * 封装目的：加入加载动画以及加载动画的最小加载时长，
     * 因为如果不加最小加载时长，如果请求速度过快，页面的加载动画会一闪一下很不美观。
     *
     * 需要注意到，方法中有一个startLoadingTime变量，
     * startLoadingTime 出现的原因是因为我们认为如果请求时间过短，就没有必要弹出加载动画，
     * 于是我们规定：如果ajax请求在一定时间内未完成（现在规定150毫秒），则出现最少显示400毫秒的加载框；
     *
     * 用法参考如下：
     *   this._ajax({
     *       url : '/apis/evaluation/schedules',
     *       datas : {
     *           type : type
     *       },
     *       success : (data)=>{
     *           console.log(data);
     *       },
     *       fail : (err)=>{
     *           console.log(err);
     *       }
     *   })
     *
     */
    Vue.prototype._ajax = function ({
      url = '',
      datas = {},
      success = () => {}, //含有一个data参数，为返回数据
      fail = () => {}, //含有一个error参数，为出错提示
      method = 'get', //请求type，默认为 'get' 类型
      showLoading = true, //是否显示加载框，默认显示
      showLoadingClose = true, //显示框加载后是否自动关闭，默认自动关闭
      testDelay = 0, //测试延迟，默认不传
    }) {
      let loading,
        loadingFlag = true,
        loadingTime = this._loadingMinTime(),
        // startLoadingTime 出现的原因是因为我们认为没有必要每次请求都带上加载动画，于是我们规定：
        // 如果ajax请求在一定时间内未完成（现在规定100毫秒），则出现最少显示400毫秒的加载框
        startLoadingTime = 100,
        actualAjaxTime = this._loadingMinTime(startLoadingTime);
      setTimeout(() => {
        showLoading && loadingFlag && (loading = this._loading());
      }, startLoadingTime);

      this._axios({
        method: method,
        [method === 'get' ? 'params' : 'data']: datas,
        url: url,
      })
        .then(function (response) {
          setTimeout(() => {
            loadingFlag = false;
            if (actualAjaxTime.loadingTime() > startLoadingTime) {
              setTimeout(() => {
                success(response.data, loading);
                showLoading && showLoadingClose && loading && loading.close();
              }, loadingTime.extraTime());
            } else {
              success(response.data, loading);
            }
          }, testDelay);
        })
        .catch(function (error) {
          setTimeout(() => {
            loadingFlag = false;
            if (actualAjaxTime.loadingTime() > startLoadingTime) {
              setTimeout(() => {
                fail(error, loading);
                showLoading && showLoadingClose && loading && loading.close();
              }, loadingTime.extraTime());
            } else {
              fail(error, loading);
            }
          }, testDelay);
        });
    };

    /*
     * 多个ajax函数的请求方法（对Vue.prototype._ajax的简单封装）
     *
     * 封装目的：多个ajax函数的请求方法时加载动画会在第一个回调中被关闭掉。
     * 这样不符合逻辑，加载框需要在最后一个回调中被关闭掉，未了实现这个目的，我使用了Promise.all()方法；
     *
     *
     * 用法参考如下：
     *   this._allAjax([{
     *       url : '/apis/evaluation/schedules',
     *       params : {
     *       },
     *       success : (data)=>{
     *           console.log(data);
     *       },
     *       fail : (err)=>{
     *           console.log(err);
     *       },
     *   },{
     *       url : '/apis/evaluation/schedules',
     *       params : {
     *       },
     *       success : (data)=>{
     *           console.log(data);
     *       },
     *       fail : (err)=>{
     *           console.log(err);
     *       },
     * }])
     *
     */
    Vue.prototype._allAjax = function (arr, fn) {
      Promise.all(
        arr.map((i) => {
          return new Promise(function (resolve, reject) {
            Vue.prototype._ajax({
              url: i.url,
              params: i.params,
              success: (data, loading) => {
                i.success(data);
                resolve(loading);
              },
              fail: (err, loading) => {
                i.fail(err);
                resolve(loading);
              },
              testDelay: i.testDelay,
              showLoadingClose: false,
            });
          });
        }),
      ).then(function (results) {
        for (var x = 0; x < results.length; x++) {
          if (results[x]) {
            results[x].close();
            break;
          }
        }
        fn && fn();
      });
    };
    //    Vue.prototype.socketIoURL = "http://localhost:8888" ;
    Vue.prototype.socketIoURL = 'https://peer.ezinterview.org:8888';
  },
};
